import { Paper, useTheme, alpha } from "@mui/material";
import { SxProps, Theme } from "@mui/system";

interface DashboardPaperProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  // Optional: render the card as another element (e.g. a router link) so the whole card is clickable.
  component?: React.ElementType;
  to?: string;
}

export default function DashboardPaper({ children, sx, component, to }: DashboardPaperProps) {
  const theme = useTheme();
  return (
    <Paper
      elevation={0}
      {...(component ? { component, to } : {})}
      sx={{
        borderRadius: 4, // 4 × default shape (4px) = 16px, matches Tailwind rounded-2xl
        border: `1px solid ${theme.palette.divider}`,
        background: theme.palette.mode === "dark"
          ? alpha(theme.palette.background.paper, 0.6)
          : theme.palette.background.paper,
        ...sx,
      }}
    >
      {children}
    </Paper>
  );
}
